import './avviso-sezione.scss';

/**
 * version    1.0
 * class      <type> (AvvisoSezione)
 * classdesc
 */
export class AvvisoSezione {}
